module.exports = __webpack_public_path__ + "static/media/food-delivery.7eb9714d.svg";